<template>
  <div class="widthFull h-100 somatoline pb-5 back-1" id="top">
    <loading v-if="loadingState" />
    <div class="row mt-5 pt-5">
      <div v-if="contests.config" class="col-12 center">
        <img :src="contests.config.LOGO_INTERNO" class="img img-fluid" />
      </div>
    </div>
    <div
      v-if="!empty && !notRegister"
      class="container"
      :class="{ 'mt-5': vw > 700 }"
    >
      <div class="back-white row justify-content-center mt-5">
        <div v-if="vw > 700" class="col-10 Bold mb-3">
          <h4 class="back-white color uppercase center padd">
            <h5>Promozione:</h5>
            {{ contests.title }}
          </h4>
        </div>
        <div v-else class="col-12 Bold mb-3">
          <small class="color uppercase Bold">Promozione: </small>
          <small class="back-white black">{{ contests.title }}</small>
        </div>
        <div class="col-md-5 center" :class="{ 'pt-5': vw > 700 }">
          <form
            :class="{ 'mt-2': vw > 700 }"
            id="edit-user-form"
            autocomplete="qwerqrt"
            @submit.prevent="callOCR"
          >
            <label
              v-if="statusOCR != 'OK'"
              class="lable-style-custom h4 Bold uppercase"
              for="tappa"
              >Carica la foto dello scontrino:</label
            >
            <label
              v-if="statusOCR == 'OK'"
              class="lable-style-custom h4 Bold uppercase"
              for="tappa"
              >Premi sulla foto per ingrandirla</label
            >
            <div class="row justify-content-center mb-5">
              <div
                :class="{
                  'group front-image center mt-3 ': !invoiceFrontBucket,
                  'group front-image-1 center mt-5': invoiceFrontBucket,
                }"
              >
                <input
                  v-if="!invoiceFrontBucket"
                  type="file"
                  v-on:change="uploadFile"
                  ref="invoice"
                  name="invoice"
                  id="invoice"
                  class="fileInput"
                  data-vv-as="Scontrino"
                  v-validate="{
                    required: true,
                    size: 10240,
                    ext: ['jpeg', 'jpg', 'png', 'pdf'],
                    mimes: [
                      'image/jpeg',
                      'image/jpg',
                      'image/png',
                      'application/pdf',
                    ],
                  }"
                  :class="{
                    'is-invalid': errors.has('invoice'),
                    valid: !!invoiceFront,
                    helper: !!invoiceFrontBucket,
                  }"
                />
                <input v-else type="file" disabled />
                <label class="niceInputLabel labelFileInput" for="invoice">
                  <span v-if="!invoiceFrontBucket">Scegli</span>
                  <viewer
                    v-else-if="
                      invoiceFrontBucket &&
                      !invoiceFrontBucket.toUpperCase().includes('.PDF')
                    "
                    class="images clearfix widthFull"
                    @inited="inited"
                  >
                    <img
                      class="img-fluid img-mod"
                      style="border-radius: 10px"
                      :src="invoiceFrontBucket"
                    />
                  </viewer>
                  <div v-else class="images clearfix widthFull" ref="inv">
                    <a
                      :href="invoiceFrontBucket"
                      target="_blank"
                      class="underline theme"
                      >Clicca qui per vedere il pdf</a
                    >
                  </div>
                  <span v-if="invoiceFrontBucket" class="Bold"
                    ><br /><font-awesome-icon
                      class="helper mr-1"
                      icon="check-circle"
                      size="1x"
                    />Scontrino caricato</span
                  >
                </label>
                <div v-if="errors.has('invoice')" class="invalid-feedback-1">
                  {{ errors.first("invoice") }}
                </div>
                <div
                  v-if="uploadFrontPercentage"
                  class="progress"
                  id="progFront"
                >
                  <div
                    class="progress-bar"
                    id="progress-bar-front"
                    role="progressbar"
                    v-bind:style="{ width: uploadFrontPercentage + '%' }"
                    aria-valuenow="50"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  >
                    {{ uploadFrontPercentage }} %
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div
          v-if="!mobileUpl && statusOCR != 'OK' && contests.config"
          class="col-md-5 center pt-5 mt-5"
        >
          <div class="row justify-content-center">
            <div class="col-12">
              <div class="mt-4 color Medium h2">Oppure:</div>
            </div>
            <div class="col-6" v-if="vw > 600">
              <a
                class="mt-1 uppercase"
                v-on:click="QRcode(token, userToken, piva)"
                ><img
                  src="../../assets/images/mobile.png"
                  class="img img-fluid"
                  style="cursor: pointer"
                /><br /><small class="black Medium"
                  >Carica la foto da cellulare</small
                ></a
              >
            </div>
            <div class="col-6" v-if="contests.config.HAS_WA">
              <a
                class="pt-1 uppercase"
                v-on:click="waLog(token, userToken, contests)"
                ><img
                  src="../../assets/images/wa.png"
                  class="img img-fluid mt-3 pt-1"
                  style="cursor: pointer"
                /><br /><small class="black Medium"
                  >Carica tramite whatsapp</small
                ></a
              >
            </div>
          </div>
        </div>
        <div
          v-if="statusOCR == 'OK'"
          class="col-md-6 mb-5 mt-md-5 pt-md-3 mb-lg-0"
        >
          <div
            id="top"
            :style="
              'background:' +
              contests.config.COLORE_CHIARO +
              '!important;border-radius:10px;padding:9px'
            "
          >
            <h5 class="uppercase mb-lg-3">Riepilogo scontrino caricato:</h5>
            <div class="row justify-content-center">
              <div
                class="col-lg-6 col-12 mb-4"
                :class="{
                  'closedBlock ': !!ocrData.numero,
                }"
              >
                <div class="group">
                  <input
                    type="number"
                    v-model="number"
                    :disabled="!!ocrData.numero"
                    class="form-control"
                    id="number"
                    name="number"
                    data-vv-as="Numero"
                    v-validate="{
                      required: true,
                      integer: true,
                      is_not: 0,
                    }"
                    :class="{
                      'is-invalid': errors.has('number'),
                      valid: !!number,
                      'form-control-dis': !!ocrData.numero,
                    }"
                  />
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="lable-style" for="number"
                    >Numero scontrino
                  </label>

                  <div v-if="errors.has('number')" class="invalid-feedback">
                    {{ errors.first("number") }}
                  </div>
                </div>
              </div>
              <div
                class="col-lg-6 col-12 mb-5 mb-md-0"
                :class="{ 'closedBlock ': !!ocrData.importo }"
              >
                <div class="group priceVal pr-0 mr-0">
                  <input
                    type="text"
                    v-model="price"
                    @focus="priceFocused = true"
                    :disabled="!!ocrData.importo"
                    class="form-control"
                    id="price"
                    name="price"
                    data-vv-as="Importo Euro"
                    v-validate="{
                      required: true,
                      regex: /^([0-9][0-9]*)$/,
                      max: 4,
                    }"
                    :class="{
                      'is-invalid': errors.has('price'),
                      valid: !!price,
                      'form-control-dis': !!ocrData.importo,
                    }"
                  />
                  <span
                    v-if="priceFocused || priceCent || price"
                    class="pseudoEuro theme"
                    >€</span
                  >
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label
                    v-if="!priceCent || (priceCent && price)"
                    class="lable-style newPriceLabel doubleRow"
                    for="price"
                    >Importo tot*</label
                  >

                  <div
                    v-if="errors.has('price')"
                    class="invalid-feedback"
                    style="width: 200%; display: block; position: absolute"
                  >
                    {{ errors.first("price") }}
                  </div>
                </div>
                <span class="theme">,</span>
                <div class="group priceCent pl-0 ml-0">
                  <input
                    type="text"
                    v-model="priceCent"
                    @focus="priceFocused = true"
                    :disabled="!!ocrData.importo"
                    class="form-control text-left centInput"
                    id="priceCent"
                    name="priceCent"
                    data-vv-as="Centesimi"
                    v-validate="{
                      required: true,
                      min: 2,
                      max: 2,
                      regex: /^([0-9]+)$/,
                    }"
                    :class="{
                      'is-invalid': errors.has('priceCent'),
                      valid: !!priceCent,
                      'form-control-dis': !!ocrData.importo,
                    }"
                  />
                  <span
                    v-if="priceFocused || priceCent || price"
                    class="pseudoCent"
                    >Cent.</span
                  >
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label
                    v-if="!price && priceCent"
                    class="niceInputLabel newPriceLabel"
                    for="price"
                    style="margin-left: -115%"
                    >Importo</label
                  >

                  <div
                    v-if="errors.has('priceCent') && !errors.has('price')"
                    class="invalid-feedback"
                    style="
                      width: 200%;
                      display: block;
                      position: absolute;
                      margin-left: -100%;
                    "
                  >
                    {{ errors.first("priceCent") }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center">
              <div
                class="col-lg-6 col-12 mb-3 mb-md-0"
                :class="{ 'closedBlock ': !!ocrData.ora }"
              >
                <div class="group">
                  <vue-timepicker
                    v-model="time"
                    class="form-control"
                    :disabled="!!ocrData.ora"
                    :hideClearButton="true"
                    data-vv-validate-on="none"
                    id="time"
                    name="time"
                    data-vv-as="Ora Scontrino"
                    v-validate="{ required: true, emptyTime: true }"
                    :class="{
                      disabledTime: !!time.HH && !!time.mm,
                      'is-invalid': errors.has('time'),
                      valid: !!time.HH != '',
                      'time-picker-dis ': !!ocrData.ora,
                    }"
                  ></vue-timepicker>

                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="lable-style labelTime" for="time"
                    >Ora scontrino</label
                  >

                  <div v-if="errors.has('time')" class="invalid-feedback">
                    {{ errors.first("time") }}
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div
                  class="mb-3 mb-md-0"
                  :class="{ 'closedBlock ': !!ocrData.data }"
                >
                  <div class="group">
                    <datepicker
                      :language="it"
                      v-model="date"
                      :disabled="!!ocrData.data"
                      :full-month-name="true"
                      :initialView="'month'"
                      :format="'dd MMMM yyyy'"
                      :monday-first="true"
                      :disabledDates="disabledDates"
                      id="date"
                      name="date"
                      input-class="form-control "
                    ></datepicker>

                    <input
                      type="text"
                      v-show="false"
                      v-model="date"
                      class="form-control"
                      id="date"
                      name="date"
                      data-vv-as="Data scontrino"
                      v-validate="{ required: true }"
                      :class="{
                        'is-invalid': errors.has('date'),
                        valid: !!date,
                        'form-control-dis': !!ocrData.data,
                      }"
                    />

                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label class="lable-style" for="date">Data scontrino</label>

                    <div v-if="errors.has('date')" class="invalid-feedback">
                      {{ errors.first("date") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="empty" class="container-fluid mt-5 pt-5">
      <div class="row justify-content-center mt-5 pt-5 back-white">
        <div class="col-md-10 center mt-5 pt-5 pb-5 mb-5">
          <h1>
            LA PROMOZIONE CHE STAI CERCANDO NON É ANCORA ATTIVA OPPURE É GIÁ
            TERMINATA
          </h1>
        </div>
      </div>
    </div>
    <div v-else-if="notRegister" class="container-fluid mt-5 pt-5">
      <div class="row justify-content-center mt-5 pt-5 back-white">
        <div class="col-md-10 center mt-5 pt-5 pb-5 mb-5">
          <h1></h1>
        </div>
      </div>
    </div>

    <div v-if="statusOCR == 'OK'" class="container back-white">
      <STEP2PRODOTTI
        :date_sc="date"
        :time_sc="time"
        :price_sc="price"
        :priceCent_sc="priceCent"
        :number_sc="number"
        :immagine_sc="invoiceFrontBucket"
        :ocrContent="saveDataOcr"
        :erroriOcr="ocrErrors"
      />
    </div>
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import { AUTH_LOGOUT } from "actions/auth";
import { USER_REQUEST } from "actions/user";
import { ACCEPT_REG } from "actions/auth";
import Datepicker from "vuejs-datepicker";
import { it } from "vuejs-datepicker/dist/locale";
import VueTimepicker from "vue2-timepicker";
import "viewerjs/dist/viewer.css";
import "vue-select/dist/vue-select.css";
import STEP2PRODOTTI from "./step_2_prodotti.vue";

const moment = require("moment");

export default {
  name: "Play",
  components: {
    Datepicker,
    VueTimepicker,
    STEP2PRODOTTI,
  },
  data() {
    return {
      loadingState: "",
      id: "",
      title: "",
      title: "",
      main_image: "",
      main_text: "",
      regulation: "",
      $viewer: "",
      faq: "",
      maxRegistration: 0,
      products_contest: [],
      contests: {},
      disabledDates: {
        to: "",
        from: "",
      },
      step1Text: "",
      step2Text: "",
      step3Text: "",
      step4Text: "",
      call_support: "",
      email_support: "",
      award_name: "",
      award_description: "",
      qntErr: false,
      qntErr1: false,
      qntErrAtt: false,
      showProdError: false,
      start: "",
      discount: "",
      end: "",
      start_: "",
      numberOcr: false,
      amountOcr: false,
      end_: "",
      products: [
        {
          index: "product" + 0,
          indexCount: "quantity" + 0,
          product: "",
          quantity: "",
          price: "",
        },
      ],
      token: "",
      quantity: "",
      wrongErr: false,
      priceError: false,
      totPrice: "",
      priceCent: "",
      price: "",
      priceFocused: false,
      invoiceFrontBucket: "",
      message: "",
      invoiceFront: "",
      it: it,
      uploadFrontPercentage: 0,
      award_image: "",
      loadingState: false,
      empty: false,
      notRegister: false,
      specific: "",
      statusOCR: "",
      change: false,
      mobileUpl: false,
      changeSecond: 0,
      award_type_: "",
      award_type: "",
      rebate: "",
      sale_date: "",
      sale_time: "",
      amount: "",
      priceEur: "",
      number: "",
      piva_shop: "",
      shop: "",
      id_image: "",
      zip: "",
      city: "",
      modify: false,
      province: "",
      ocrData: {},
      type: "",
      showProdError: false,
      minProduct: "",
      maxSelOk: false,
      minPrice: "",
      regex: "",
      minErr: false,
      myAttempts: "",
      discountClients: "",
      pricenew: "",
      errProd: false,
      canCon: false,
      INF: "",
      reload: false,
      vw: window.innerWidth,
      imageData: {},
      date: "",
      time: {
        HH: "",
        mm: "",
      },
      priceMod1: false,
    };
  },
  methods: {
    loadProducts: async function () {
      this.loadingState = true;
      this.$track("loadProducts", "START");
      var data = {
        id: this.$route.params.id,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/loadProducts",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.$track("loadProducts", "SUECCESS");
          this.$track("loadProducts", [resp.data]);
          var prod = [];
          for (var x in resp.data) {
            var y = [];
            y["key"] = x;
            y["label"] = resp.data[x];
            y["value"] = resp.data[x];
            prod.push(y);
          }
          this.products_contest = resp.data;
          this.loadingState = false;
        })
        .catch((resp) => {
          this.loadingState = false;
          this.$track("loadProducts", "ERROR");
        });
    },
    checkAccess: async function () {
      if (this.piva == this.$route.params.piva) {
        this.$track("checkAccess", "START");
        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          profile: this.profile,
          case: "PLAY",
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/checkAccess",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.loadingState = false;
            this.checkAccessOk = true;
            this.$track("checkAccess", "SUCCESS");
            this.$track("checkAccess", resp.data);
            if (resp.data == "access_denied") {
              this.message =
                '<b class="Bold">Non hai accesso a questa promozione</b>';
              this.UploadError("", this.message);
            } else if (resp.data == "no_promo_active") {
              this.message =
                '<b class="Bold">La promozione a cui si sta cercando di accedere non è piú attiva</b>';
              this.UploadError("", this.message);
            }
          })
          .catch((err) => {
            this.loadingState = false;
            this.$track("checkAccess", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      } else {
        this.$router.push("/");
      }
    },
    QRcode(token, userToken, piva) {
      this.loadingState = true
      var text;
      var params;
      this.steps = token.replaceAll("/", "2TGRS2");
      this.steps1 = this.steps.replaceAll(".", "3MULTI3");
      this.idPass = "WERgt4r2sfr" + this.$route.params.id + "REWrfs2r4tg";
      var tkPssaggio = this.$encryptByAES(
        JSON.stringify(this.userToken),
        process.env.CRYPTKEY
      );
      this.tokenPass = "TOKhgsfddte" + tkPssaggio + "KOTnaskdue";
      params = this.idPass + "" + this.steps1 + "" + this.tokenPass;
      text = encodeURI(process.env.DIRECTORY + "/uploadphone/" + params);
      this.$track("QRcode", "START");
      this.$track("QRcode", text);
      console.log("For QRCode: " + text);
      var data = {
        text: text,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        method: "POST",
        data: {
          data,
        },
        url: process.env.ROOT_API + "api/Qrcode",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false
          this.$track("QRcode", "SUCCESS");
          this.$track("QRcode", resp.data);
          this.$swal({
            html: '<h5 class="Bold black">Scannerizza il QRcode per caricare le immagini dal tuo telefono</h5>',
            width: 555,
            imageUrl: resp.data,
            allowOutsideClick: false,
            confirmButtonText: "CHIUDI",
            confirmButton: "closeProductsModal",
            confirmButtonClass: "btn btn-secondary",
            onClose: () => {
              this.$router.push(
                "/contest/" +
                  this.$route.params.id +
                  "/" +
                  this.$route.params.piva +
                  "/" +
                  this.$route.params.cod
              );
            },
          });
        })
        .catch((resp) => {});
    },

    waLog(token, userToken, config) {
      if (this.getProfile.phone) {
        var newline = "%0a";
        var newlineD = "%0a%0a";
        var text = newline;
        text +=
          "Benvenuto nella chat della piattaforma Laboratoire Native: Il suo codice farmacista è: " +
          this.getProfile.cod +'. In questa chat potrá effettuare i caricamenti per la promozione '+config.title 
        if (config.config.AGGREGATE_PROMO)
          text +=
            "Questa chat potrá essere utilizzata anche per il caricamento della promozione: " +
            config.config.AGGREGATE_PROMO_TITLE
        var url =
          "https://wa.me/39" + config.config.WA_NUMBER + "?text=" + text;
        window.open(url, "_blank").focus();
      } else {
        this.$router.push("/phone/"+config.id+'/'+this.$encryptByAES(JSON.stringify(moment()), process.env.CRYPTKEY));
      }
    },
    async checkIfDuplicated(content) {
      this.$track("checkIfDuplicated", "START");
      var data = {
        content: content,
        promoid:this.contests.id,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      let res = await axios({
        data: { data },
        url: process.env.ROOT_API + "api/checkIfDuplicated",
        method: "POST",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.$track("checkIfDuplicated", "SUCCESS");
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          return true;
        })
        .catch((err) => {
          this.$track("checkIfDuplicated", "ERROR");
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
          return false;
        });

      return res;
    },
    saveOcrError(ocrErrors, type) {
      // OCR ERRORS DESCRIPTION
      var html = "";
      var _vue = this;

      this.calcInvoiceStatusOcr(ocrErrors);

      if (type == "afterOcr") {
        // AFTER OCR
        for (var i in ocrErrors) {
          if (ocrErrors[i].status == "KO") {
            if (ocrErrors[i].description) {
              html +=
                '<h4 class="smallText">' + ocrErrors[i].description + "</h4>";
            }
            if (this.invoiceStatusOcr == 217) {
              html +=
                "<br />Letta : [" +
                _vue.piva_shop +
                "]<br />Farmacia: [" +
                this.piva +
                "]";
            }
          }
        }

        var imageUrl = _vue.ocrData["invoiceFrontBucket"];
        var res = _vue.ocrData;
        var invData = res.data;
        var invImporto = res.importo;
        var invNumero = res.numero;
        var invOra = res.ora;
        var award = "";
        var action = "ocr_error";
      } else {
        // BEFORE OCR => dublicate
        this.$track(909);
        this.$track(ocrErrors);

        html +=
          "Duplicato immagine con ID: " +
          ocrErrors.duplicated.duplicated_list[0].id +
          ' <a class="link" href="' +
          ocrErrors.duplicated.duplicated_list[0].url +
          '" target="_blank" style="color:red">FOTO</a>';
        this.invoiceStatusOcr = "250";
        var imageUrl = ocrErrors.duplicated.duplicated_list[0].url;
        var invData = "";
        var invImporto = "";
        var invNumero = "";
        var invOra = "";
        var award = "";
        var action = "duplicate_image";
      }

      // AWARD
      if (_vue.podium1Selected) {
        award = "x ";
      } else {
        award = "x ";
      }

      _vue.dataForError = {
        profile: this.profile,
        promo: this.contests,
        sdate_submit: moment().format("YYYY-MM-DD hh:mm:ss"),
        ttdate: invData,
        ttime: invOra,
        tvalue: invImporto,
        tnumber: "",
        rebate: "",
        ntk: process.env.AUTH_TOKEN,
        uid: "",
        products: "",
        receipts_uploads: [{ url1: imageUrl }],
        award: "",
        discountSpec: "",
        rebateSpec: "",
        ocrData: this.saveDataOcr,
        status: "error",
        INF: this.INF,
        code: _vue.invoiceStatusOcr,
        description: html,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      var data = _vue.dataForError;
      this.$track("saveOcrError", "START");
      this.$track("saveOcrError", data);
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        data: { data },
        url: process.env.ROOT_API + "api/saveOcrError",
        method: "POST",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.$track("saveOcrError", "SUCCESS");
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          _vue.invoiceFront = "";
          _vue.invoiceFrontName = "";
          _vue.invoiceFrontBucket = "";
          _vue.uploadFrontPercentage = 0;
          _vue.invoiceRear = "";
          _vue.invoiceRearName = "";
          _vue.invoiceRearBucket = "";
          _vue.ocrErrors = {};
          _vue.haveError = false;
        })
        .catch((err) => {
          this.$track("saveOcrError", "ERROR");
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
        });
    },
    checkSoftwareVersion() {
      console.log("CHECK VERSION SW ************");
      var version = localStorage.getItem("sw_version");

      if (!version) {
        console.log("VERSION NOT SAVED => " + version);
        version = false;
      } else {
        console.log("ACTUAL VERSION => " + version);
      }
      var data = {
        version: version,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      axios({
        url: process.env.ROOT_API + "api/checkSoftwareVersion",
        method: "POST",
        data: { data },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          if (resp.data.version) {
            console.log("SERVER VERSION => " + resp.data.version);
            if (version != resp.data.version) {
              localStorage.setItem("sw_version", resp.data.version);
              window.location.reload();
            }
          }
        })
        .catch((error) => {});
    },
    uploadFile: function (input) {
      this.$track("uploadFile", "START");
      this.$track("uploadFile", input);
      this.inputFile = input;
      var file = input.target.files[0].name;
      var extension = file.substr(file.lastIndexOf(".") + 1).toLowerCase();
      var size = input.target.files[0].size;
      this.filename1 = file;
      if (
        (extension == "png" ||
          extension == "jpg" ||
          extension == "jpeg" ||
          extension == "pdf") &&
        size < 10240000
      ) {
        this.invoiceFront = input.target.files[0].name;
        var formData = new FormData();
        var _vue = this; // << here
        formData.append("file", input.target.files[0]);
        var keyP = {
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
          id_platform: process.env.ID_PLATFORM,
        };
        if (process.env.CRYPT == "ON")
          keyP = this.$encryptByAES(JSON.stringify(keyP), process.env.CRYPTKEY);
        else keyP = JSON.stringify(keyP);
        formData.append("key", keyP);
        axios
          .post(process.env.ROOT_API + "api/uploadImage", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
            },
            onUploadProgress: function (progressEvent) {
              this.uploadFrontPercentage = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }.bind(this),
          })
          .then(function (e) {
            var regex =
              /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
            if (regex.test(e.data.url)) {
              _vue.uploadFrontPercentage = 0;
              _vue.invoiceFrontBucket = e.data.url;
              _vue.callOCR(e.data);
            } else {
              _vue.uploadFrontPercentage = 0;
              _vue.invoiceFront = "";
              _vue.invoiceFrontBucket = "";
              _vue.UploadError();
              input.target.value = null;
            }
          })
          .catch(function () {
            _vue.uploadFrontPercentage = 0;
            _vue.invoiceFront = "";
            _vue.invoiceFrontBucket = "";
            _vue.UploadError();
            input.target.value = null;
          });
      }
    },

    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push("/login"));
    },
    inited(viewer) {
      var _vue = this;
      this.$viewer = viewer;
      setTimeout(function () {
        _vue.$viewer.zoom(1);
      }, 1000);
    },
    show() {
      var el = this.$refs.inv;
      const viewer = el.$viewer;
      viewer.show();
      viewer.zoomTo(2);
      viewer.move(-1, 0);
    },
    showError(text) {
      this.$swal({
        type: "error",
        title: '<strong class="Bold">Oops...</strong>',
        html: text,
        confirmButtonText: "CHIUDI",
        confirmButton: "closeProductsModal",
        confirmButtonClass: "btn btn-secondary",
        onClose: () => {
          this.$router.push(
            "/contest/" +
              this.$route.params.id +
              "/" +
              this.$route.params.piva +
              "/" +
              this.$route.params.cod
          );
        },
      });
    },

    resetForm() {
      var _vue = this;
      this.$validator.pause();
      this.mail = "";
      this.sdate_submit = "";
      this.ttdate = "";
      this.ttime = "";
      this.tvalue = "";
      this.tnumber = "";
      this.user_token = "";
      this.name = "";
      this.company = "";
      this.sname = "";
      this.piva = "";
      this.iban = "";
      this.address = "";
      this.tel = "";
      this.ntk = "";
      this.uid = "";
      this.receipts = "";
      this.ocrData = "";
      this.products = "";
      setTimeout(function () {
        _vue.checkProducts(1);
      }, 200);
      // CLEAR VALIDATOR AFTER REMOVE ALL VALUES
      this.$nextTick(() => {
        this.$validator.reset();
        this.$validator.errors.clear();
        this.$validator.resume();
      });
    },

    showPlay() {
      var _vue = this;
      var text =
        '<h5 class="text-center uppercase">L`inserimento della richiesta di rapi/pimborso é andata a buon fine.</h5> ';
      //text += '<p class="text-center Bold mt-1 pt-5">Ti verrá comunicato tramite mail l`esito della giocata e le istruzioni per ricevere il premio</p>'
      text += '<p class="white"> <br /></p>';
      text += '<p class="white"> <br /></p>';
      text += '<p class="white"> <br /></p>';

      var mySwal = this.$swal;
      mySwal({
        title:
          '<div class="col-12 center d-flex justify-content-center" style="width:700px"><div class="w-25 px-2 px-md-3 line-h4"><hr /></div><h4 class="text-center Bold">ESITO</h4><div class="w-25 px-2 px-md-3 line-h4"><hr /></div></div>',
        html: text,
        showCloseButton: true,
        width: 1000,
        //background: 'linear-gradient(180deg, black 0%, black 13%, #ed1b34 14%, #ed1b34 100%)',
        showConfirmButton: false,
        confirmButton: "closeProductsModal",
        confirmButtonClass: "btn btn-secondary",
        onClose: () => {
          if (this.mobileUpl) {
            window.location.reload();
          } else {
            this.$router.push(
              "/contest/" +
                this.$route.params.id +
                "/" +
                this.$route.params.piva +
                "/" +
                this.$route.params.cod
            );
          }
        },
      });
    },
    doAcceptReg(value) {
      this.$store.dispatch(ACCEPT_REG, value).then((resp) => {});
    },
    UploadError(desc, specific) {
      this.$swal({
        type: "error",
        title: desc,
        html: specific,
        confirmButtonText: "CHIUDI",
        confirmButtonColor: "#15267",
        onClose: () => {
          this.$router.push("/");
        },
      });
    },
    async callOCR() {
      await this.getThisContest();
      //this.empty = true;
      if (!this.empty) {
        this.$validator.validate().then((valid) => {
          if (valid && !this.countError) {
            this.loadingState = true;
            var img = this.invoiceFrontBucket;
            var _vue = this;

            axios({
              url: "https://api.ocrtag.com/receipt",
              method: "POST",
              data: {
                icode: process.env.ICODE,
                front: img,
              },
              headers: {
                Authorization: "Bearer " + process.env.API_TOKEN,
                "Content-type": "application/json",
              },
            })
              .then(async (resp) => {
                this.$track("callOCR", "000");
                var _vue = this;
                var newOCRResponce = resp.data;
                var notInvoice = false;
                this.$track("callOCR", resp.data);
                ///////////////////////////////////////////////////
                if (!newOCRResponce.hasOwnProperty("receipt")) {
                  this.$track("callOCR", "OCR => RECEIPT NOT HAVE ANY DATA");
                  var x = {};
                  x.date = "";
                  x.time = "";
                  x.number = "";
                  x.amount = "";
                  x.vatnum = "";
                  x.shop = "";
                  var y = {};
                  y.location;
                  y.zip = "";
                  y.province = "";
                  x.address = y;
                  newOCRResponce.content = "";
                  var z = {};
                  z.status = "no";
                  newOCRResponce.duplicated = z;
                  var c = {};
                  c.status = "no";
                  newOCRResponce.manipulated = c;
                  newOCRResponce.receipt = x;
                  notInvoice = true;
                }
                ////////////////////////////////////////////////
                this.$track("callOCR", "111");
                // REMOVE ALL EX RESULT
                _vue.price = "";
                _vue.priceCent = "";
                _vue.date = "";
                _vue.time.HH = "";
                _vue.time.mm = "";
                _vue.number = "";
                _vue.ocrResp = resp.data;
                _vue.haveError = false;
                this.$track("callOCR", "222");
                var responce = {};
                responce.data = newOCRResponce.receipt.date;
                responce.ora = newOCRResponce.receipt.time;
                responce.numero = newOCRResponce.receipt.number;
                responce.importo = newOCRResponce.receipt.amount;
                responce.city = newOCRResponce.receipt.address.location;
                responce.zip = newOCRResponce.receipt.address.zip;
                responce.province = newOCRResponce.receipt.address.province;
                responce.products = {};
                responce.iva = newOCRResponce.receipt.vatnum;
                responce.issetProducts = true;
                responce.insegna = newOCRResponce.receipt.shop;
                responce.rows = newOCRResponce.content;
                responce.duplicated = newOCRResponce.duplicated;
                _vue.saveDataOcr = newOCRResponce.content;
                _vue.ocrData = responce;
                //////////////////////////////////////////////
                // CONVERT DUPLICATED AND MANIPULATED
                _vue.imageData.exif = {};
                _vue.imageData.exif.all_exif_data = {};
                _vue.imageData.custom_keys = "";
                var check = true;
                if (newOCRResponce.duplicated.status == "yes") {
                  let check = await _vue.checkIfDuplicated(
                    newOCRResponce.content
                  );
                  this.$track("callOCR", "check if duplicated => " + check);
                  if (!check) {
                    _vue.statusOCR = "KO";
                    _vue.showDublicateImage(_vue.filename1);
                    // SAVE PLAY
                    _vue.saveOcrError(responce, "beforeOcr");
                    _vue.uploadFrontPercentage = 0;
                    _vue.invoiceFront = "";
                    _vue.invoiceFrontBucket = "";
                    //_vue.input = input;
                    _vue.filename1 = "";
                    //input.value = null;
                    _vue.loadingState = false;
                    _vue.ocrResult = "KO";
                    if (_vue.invoiceRearBucket) {
                      _vue.uploadRearPercentage = 0;
                      _vue.invoiceRear = "";
                      _vue.invoiceRearBucket = "";
                      _vue.input2 = null;
                      _vue.filename2 = "";
                    }
                  }
                }
                this.$track("callOCR", "223");
                if (check) {
                  _vue.softCheck = "";
                  // CHECK SOFT AND Tags
                  if (newOCRResponce.manipulated.status == "yes") {
                    _vue.softCheck += newOCRResponce.manipulated.type;
                    _vue.invoiceStatus = "601";
                  }
                  var ocrErrors = {
                    date: {
                      status: "KO",
                      error: false,
                      description: false,
                    },
                    time: {
                      status: "KO",
                      error: false,
                      description: false,
                    },
                    number: {
                      status: "KO",
                      error: false,
                      description: false,
                    },
                    amount: {
                      status: "KO",
                      error: false,
                      description: false,
                    },
                    iva: {
                      status: "KO",
                      error: false,
                      description: false,
                    },
                    count: 0,
                  };
                  // **********************************************************************************************
                  ////////////////////////////////////////
                  ////////////////////////////////////////
                  // DATE CONTROL
                  ////////////////////////////////////////
                  if (responce.data) {
                    var date = moment(responce.data, "DD/MM/YYYY");
                    // check if date is valid
                    if (date.isValid()) {
                      var y = date.format("YYYY");
                      var m = date.format("MM");
                      var d = date.format("DD");

                      if (y > 2301) {
                        ocrErrors.date.error = "invalid_date";
                        _vue.ocrData.data = "";
                        ocrErrors.count = ocrErrors.count + 1;
                        ocrErrors.date.description =
                          "La data dello scontrino non valida";
                        _vue.haveError = true;
                      } else if (m > 12) {
                        ocrErrors.date.error = "invalid_date";
                        _vue.ocrData.data = "";
                        ocrErrors.count = ocrErrors.count + 1;
                        ocrErrors.date.description =
                          "La data dello scontrino non valida";
                        _vue.haveError = true;
                      } else if (d > 31) {
                        ocrErrors.date.error = "invalid_date";
                        _vue.ocrData.data = "";
                        ocrErrors.count = ocrErrors.count + 1;
                        ocrErrors.date.description =
                          "La data dello scontrino non valida";
                        _vue.haveError = true;
                      } else {
                        // check if date in period of promo
                        var start = moment(_vue.start_rec, "DD/MM/YYYY");
                        var end = moment(_vue.end_rec, "DD/MM/YYYY");
                        var now = moment();
                        var then = moment(date);
                        var dif = then.diff(now);
                        var duration = moment.duration(dif, "milliseconds");
                        var days = duration.asDays();
                        if (date >= start && date <= end) {
                          ocrErrors.date.status = "OK";
                          _vue.date = date.format("YYYY-MM-DD");
                          this.$track("callOCR", "Data: " + _vue.date);
                          /*if (days < -6) {
                          ocrErrors.date.error = "not_play_period";
                          ocrErrors.count = ocrErrors.count + 1;
                          ocrErrors.date.description =
                            "Sono passati piú di 5 giorni compreso oggi dalla data di acquisto riportata sul documento di vendita";
                          ocrErrors.date.status = "KO";
                        }*/
                        } else {
                          ocrErrors.date.error = "not_play_period";
                          ocrErrors.count = ocrErrors.count + 1;
                          ocrErrors.date.description =
                            "La data dello scontrino non rientra nel periodo del concorso";
                          _vue.haveError = true;
                          ocrErrors.date.status = "KO";
                        }
                      }
                    } else {
                      ocrErrors.date.error = "invalid_date";
                      _vue.ocrData.data = "";
                      ocrErrors.count = ocrErrors.count + 1;
                      ocrErrors.date.description =
                        "La data dello scontrino non valida";
                      _vue.haveError = true;
                    }
                  } else {
                    ocrErrors.count = ocrErrors.count + 1;
                    ocrErrors.date.error = "missing_date";
                    ocrErrors.date.description =
                      "La data dello scontrino mancante";
                    _vue.haveError = true;
                    ocrErrors.date.status = "KO";
                  }
                  ////////////////////////////////////////
                  ////////////////////////////////////////
                  // TIME CONTROL
                  ////////////////////////////////////////
                  if (newOCRResponce.receipt.type != "ddc") {
                    if (responce.ora) {
                      var time = responce.ora;
                      var hour = time.substring(0, 2);
                      var minute = time.substring(3, 5);
                      if (
                        parseInt(hour) >= 0 &&
                        parseInt(hour) <= 24 &&
                        minute >= 0 &&
                        minute <= 60
                      ) {
                        //_vue.time.HH = hour
                        //_vue.time.mm = minute
                        _vue.time = { HH: hour, mm: minute };
                        ocrErrors.time.status = "OK";
                        _vue.ocrData.ora = 200;
                      } else {
                        ocrErrors.time.error = "invalid_time";
                        ocrErrors.count = ocrErrors.count + 1;
                        ocrErrors.time.description =
                          "L`ora dello scontrino non valida";
                        _vue.haveError = true;
                        _vue.time = {};
                        _vue.ocrData.ora = "";
                      }
                    } else {
                      ocrErrors.count = ocrErrors.count + 1;
                      ocrErrors.time.error = "missing_time";
                      ocrErrors.time.description =
                        "L`ora dello scontrino mancante";
                      _vue.haveError = true;
                    }
                  } else {
                    ocrErrors.time.status = "OK";
                    _vue.time = { HH: "00", mm: "00" };
                  }
                  this.$track("callOCR", "Ora: " + hour + ":" + minute);
                  ////////////////////////////////////////
                  /////////////////////////////////////////
                  // NUMBER CONTROL
                  ///////////////////////////////////////
                  if (responce.numero) {
                    var num = responce.numero;
                    num = num.toString();
                    num = num.replace("-", "");
                    _vue.number = num;
                    ocrErrors.number.status = "OK";
                  } else {
                    ocrErrors.count = ocrErrors.count + 1;
                    ocrErrors.number.error = "missing_number";
                    ocrErrors.number.description =
                      "Numero dello scontrino mancante";
                    _vue.haveError = true;
                  }
                  this.$track("callOCR", "Numero: " + _vue.number);
                  ////////////////////////////////////////
                  ///////////////////////////////////////
                  // AMMOUNT CONTROL
                  ///////////////////////////////////////
                  if (responce.importo) {
                    var amount = responce.importo.split(",");
                    ocrErrors.amount.status = "OK";
                    _vue.price = amount[0];
                    _vue.priceCent = amount[1];

                    if (parseInt(_vue.price) < process.env.OCR_MIN_AMOUNT) {
                      ocrErrors.amount.status = "KO";
                      ocrErrors.amount.error = "price_less";
                      ocrErrors.amount.description =
                        "Importo dello scontrino è inferiore a " +
                        process.env.OCR_MIN_AMOUNT +
                        " Euro";
                      ocrErrors.count = ocrErrors.count + 1;
                      _vue.haveError = true;
                    }
                  } else {
                    ocrErrors.count = ocrErrors.count + 1;
                    ocrErrors.amount.error = "missing_amount";
                    ocrErrors.amount.description =
                      "Importo dello scontrino mancante";
                    _vue.haveError = true;
                  }
                  this.$track("callOCR", "Prezzo: " + _vue.price);
                  ///////////////////////////////////////
                  //////////////////////////////////////
                  //P.IVA
                  ///////////////////////////////////////
                  if (this.group != 1) {
                    if (responce.iva) {
                      if (responce.iva != this.piva) {
                        ocrErrors.count = ocrErrors.count + 1;
                        ocrErrors.iva.error = "piva_not_correspond";
                        ocrErrors.iva.description =
                          "La partita iva dello scontrino caricato non corrisponde con la partita iva del tuo negozio";
                        _vue.haveError = true;
                      } else {
                        this.$track("callOCR", "Il Negozio: " + this.piva);
                        ocrErrors.iva.status = "OK";
                      }
                    } else {
                      ocrErrors.count = ocrErrors.count + 1;
                      ocrErrors.iva.error = "piva_not_correspond";
                      ocrErrors.iva.description =
                        "Purtroppo questa prova d'acquisto non sembra includere alcun punto vendita aderente all'iniziativa";
                      _vue.haveError = true;
                    }
                  } else {
                    this.$track(
                      "callOCR",
                      "Gruppo di Piva :" + this.piva + " gruppo : " + this.group
                    );
                    ocrErrors.iva.status = "OK";
                    if (responce.iva) {
                      _vue.softCheck +=
                        "Farmacia associata ad un gruppo<br /><br />Letta : [" +
                        responce.iva +
                        "]<br />Farmacia: [" +
                        this.piva +
                        "]";
                    } else {
                      _vue.softCheck +=
                        "Farmacia associata ad un gruppo<br /><br />Non rilevata <br />Farmacia: [" +
                        this.piva +
                        "]";
                    }
                  }
                  this.$track("callOCR", "Partita iva letta: " + responce.piva);
                  this.$track("callOCR", "Partita iva mia: " + _vue.piva);
                  ////////////////////////////////////////
                  ////////////////////////////////////////
                  console.error(ocrErrors);
                  // **********************************************************************************************
                  if (
                    ocrErrors.amount.error != "price_less" &&
                    ocrErrors.count <= 2 &&
                    ocrErrors.date.error != "not_play_period" &&
                    ocrErrors.iva.error != "piva_not_correspond" &&
                    ((ocrErrors.date.status == "OK" &&
                      ocrErrors.time.status == "OK") ||
                      (ocrErrors.date.error == "invalid_date" &&
                        ocrErrors.time.status == "OK") ||
                      (ocrErrors.time.error == "invalid_time" &&
                        ocrErrors.date.status == "OK") ||
                      (ocrErrors.date.status == "OK" &&
                        ocrErrors.time.status == "KO"))
                  ) {
                    if (
                      ocrErrors.amount.status == "KO" &&
                      ocrErrors.number.status == "KO"
                    ) {
                      _vue.invoiceStatus = "605";
                    }
                    if (
                      ocrErrors.amount.status == "OK" &&
                      ocrErrors.number.status == "KO"
                    ) {
                      _vue.invoiceStatus = "604";
                    }
                    if (
                      ocrErrors.amount.status == "KO" &&
                      ocrErrors.number.status == "OK"
                    ) {
                      _vue.invoiceStatus = "603";
                    }

                    _vue.ocrErrors = ocrErrors;
                    _vue.ocrResult = "OK";
                    _vue.statusOCR = "OK";
                    _vue.uploadFrontPercentage = 0;
                    _vue.uploadRearPercentage = 0;
                    _vue.invoiceFrontBucket = img;
                    _vue.loadingState = false;
                    setTimeout(function () {
                      _vue.$validator.validate();
                    }, 2000);
                  } else {
                    if (notInvoice) {
                      _vue.invoiceStatusOcr = "606";
                    }
                    // rewrite data to variable
                    _vue.ocrData["invoiceFrontBucket"] =
                      _vue.invoiceFrontBucket;
                    _vue.loadingState = false;
                    _vue.ocrResult = "KO";
                    _vue.ocrErrors = ocrErrors;
                    _vue.uploadFrontPercentage = 0;
                    _vue.invoiceFront = "";
                    _vue.invoiceFrontBucket = "";
                    _vue.input = null;
                    _vue.filename1 = "";
                    if (_vue.invoiceRearBucket) {
                      _vue.uploadRearPercentage = 0;
                      _vue.invoiceRear = "";
                      _vue.invoiceRearBucket = "";
                      _vue.input2 = null;
                      _vue.filename2 = "";
                    }
                    _vue.saveOcrError(_vue.ocrErrors, "afterOcr");
                    _vue.showErrorOCR(_vue.ocrErrors);
                  }
                }

                //}
              })
              .catch((resp) => {
                //_vue.UploadError(resp.response.data.description);
                _vue.loadingState = false;
              });
          } else {
            //this.$scrollTo('#' + this.errors.items[0].field, 700, {offset: -170})
          }
        });
      }
    },
    showDublicateImage(img) {
      this.$swal({
        type: "error",
        title: "Ops!",
        html: '<p class="center smallText">Lo scontrino</p> <p class="center smallText"></p><p class="center smallText"> risulta essere già caricato</p>',
        confirmButtonText: "CHIUDI",
        onClose: () => {
          window.location.reload();
        },
      });
    },

    showErrorOCR(text) {
      var html =
        '<p class="smallText text-left">Nell`immagine caricata:</p><ul>';
      var x = 0;
      var z = 0;
      for (var i in text) {
        if (text[i].status == "KO") {
          if (text[i].description) {
            html +=
              '<li class="smallText text-left">' +
              text[i].description +
              "</li>";
          }

          x++;
        }
      }
      html += "</ul>";
      if (x >= 4) {
        html =
          '<p class="smallText text-left">Purtroppo l`immagine caricata non sembra essere quella di un scontrino.</p>';
        html +=
          '<ul><li class="smallText text-left">I dati sullo scontrino devono essere ben visibili.</li>';
        html +=
          '<li class=" smallText text-left mt-2">Se lo scontrino è troppo lungo, piegalo a fisarmonica per mostrare solo i dati necessari</li></ul> ';
        html +=
          '<li class=" smallText text-left mt-2">La foto caricata deve avere un peso compreso fra 12KB e 10MB</li></ul> ';
        html +=
          '<p class="smallText text-left mt-3">Prova a rifare la foto e ricarica lo scontrino</p> ';
        z = 4;
      } else if (x <= 3) {
        html += '<p class="smallText text-left">Attenzione!</p>';
        if (x == 1 && text.date.error == "not_play_period") {
          // IF ONLY DATE OUT OF PERIOD
          // html += '<ul><li class="smallText text-left">Sono passati piú di 5 giorni compreso oggi dalla data di acquisto riportata sul documento di vendita.</li></ul>'
        } else {
          // IF MANY ERRORS
          html +=
            '<ul><li class="smallText text-left">I dati sullo scontrino devono essere ben visibili.</li>';
          html +=
            '<li class=" smallText text-left mt-2">Se lo scontrino è troppo lungo piegalo a fisarmonica per mostrare solo i dati necessari</li>';
          html +=
            '<li class=" smallText text-left mt-2">La foto caricata deve avere un peso compreso fra 12KB e 10MB</li></ul> ';
          html +=
            '<p class="smallText text-left mt-3">Prova a rifare la foto e ricarica lo scontrino</p> ';
        }
      }
      this.$swal({
        type: "error",
        title: '<strong class="">Ops!</strong>',
        html: html,
        confirmButtonText: "Esempio scontrino",
        confirmButtonColor: "#15267",
        showCancelButton: true,
        cancelButtonText: "Chiudi",
        cancelButtonColor: "black",
      })
        .then((okay) => {
          if (okay.dismiss) {
            window.location.reload();
          }
          if (okay.value) {
            this.$swal.fire({
              imageUrl: require("../../assets/images/invoice-example.png"),
              imageAlt: "A tall image",
              width: "70%",
              imageClass: "image-margin0",
              showConfirmButton: false,
              showCancelButton: true,
              cancelButtonText: "Chiudi",
              cancelButtonColor: "black",
              onClose: () => {
                window.location.reload();
              },
            });
          }
        })
        .catch((resp) => {
          window.location.reload();
        });
    },

    calcInvoiceStatusOcr(ocrErrors) {
      var errors = ocrErrors;

      if (errors.count) {
        if (errors.count == 4) {
          this.invoiceStatusOcr = "606";
        } else if (errors.count == 3) {
          // OK DATA
          if (errors.date.status == "OK") {
            this.invoiceStatusOcr = "611";
          }
          // OK ORA
          if (errors.time.status == "OK") {
            this.invoiceStatusOcr = "612";
          }
          // OK IMPORTO
          if (errors.amount.status == "OK") {
            this.invoiceStatusOcr = "608";
          }
          // OK NUMERO
          if (errors.number.status == "OK") {
            this.invoiceStatusOcr = "607";
          }
        } else if (errors.count == 2) {
          // IF I AM HERE => ONLY DATA ORA MISSING
          this.invoiceStatusOcr = "609";
        }

        if (errors.date.error == "not_play_period") {
          this.invoiceStatusOcr = "610";
        }
        if (errors.iva.error == "piva_not_correspond") {
          this.invoiceStatusOcr = "617";
        }
      }
    },
    getThisContest: async function () {
      this.loadingState = true;
      this.$track("getThisContest", "START");
      var data = {
        id: this.$route.params.id,
        status: "ACTIVE",
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/getThisContest",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("getThisContest", "SUCCESS");
          if (resp.data) {
            this.empty = false;
          }
          for (var i in resp.data) {
            var pass = JSON.parse(resp.data[i].config);
            resp.data[i].config = pass;
          }
          this.contests = resp.data[0];

          this.type = this.contests.config.TIPOLOGIA_RIEPILOGO;
          this.start_ = this.contests.start;
          this.start = moment(this.start_).format("DD-MM-YYYY");
          this.end_ = this.contests.end;
          this.end = moment(this.end_).format("DD-MM-YYYY");
          this.startRec_ = this.contests.startRec;
          this.start_rec = moment(this.startRec_).format("DD/MM/YYYY");
          this.endRec_ = this.contests.endRec;
          this.end_rec = moment(this.endRec_).format("DD/MM/YYYY");

          this.now = moment();
          var then = moment(this.end_);

          var dif = then.diff(this.now);
          if (dif <= 0) {
            this.finish = true;
            this.countdown = 0 - dif;
          } else {
            this.countdown = dif;
          }
          this.$track("getThisContest", this.contests);
        })
        .catch((err) => {
          this.loadingState = false;
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
          this.$track("getThisContest", "ERROR");
        });
    },
    takeMyAttempts: async function () {
      this.loadingState = true;
      this.$track("takeMyAttempts", "START");
      var data = {
        id: this.$route.params.id,
        piva: this.$route.params.piva,
        cod: this.$route.params.cod,
        group: this.group,
        promo:this.contests,
        desc: this.contests.config.DESTINAZIONE_SCONTO,
        profile: this.profile,
        id_platform: process.env.ID_PLATFORM,
        unique_key_db: process.env.UNIQUE_KEY_DB,
        vector_unique_key_db: process.env.ICODE,
      };
      data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
      await axios({
        method: "POST",
        data: { data },
        url: process.env.ROOT_API + "api/takeMyAttempts",
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
          this.$track("takeMyAttempts", "SUCCESS");
          resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
          this.$track("takeMyAttempts -> MY", resp.data);
          this.$track("takeMyAttempts -> MAX", this.maxRegistration);
          this.my_registration_in_promo = resp.data.countMyAttempts;
          if (this.my_registration_in_promo >= this.maxRegistration) {
            this.$track(
              "takeMyAttempts -> RAGGIUNTO MASSIMO",
              this.my_registration_in_promo + " >= " + this.maxRegistration
            );
            this.notRegister = true;
            var _vue = this;
            var text;
            var text =
              '<h5 class="text-center uppercase red">Hai raggiunto il numero massimo di richieste di rimborso disponibili per questa promozione</h5> ';
            text +=
              '<p class="text-center Bold mt-1 pt-5 red">Il numero massimo di richieste di rimborso per questa promozione é <h3 class="bordered back-color-1 white">' +
              this.maxRegistration +
              "</h3></p>";
            var mySwal = this.$swal;
            mySwal({
              html: text,
              showCloseButton: true,
              width: 555,
              color: "red",
              showConfirmButton: false,
              confirmButton: "closeProductsModal",
              confirmButtonClass: "btn btn-secondary",
              onClose: () => {
                this.$router.push(
                  "/contest/" +
                    this.$route.params.id +
                    "/" +
                    this.$route.params.piva +
                    "/" +
                    this.$route.params.cod
                );
              },
            });
          }
        })
        .catch((err) => {
          this.loadingState = false;
          this.$track("takeMyAttempts", "ERROR");
          err.response.data = this.$decryptByAES(
            err.response.data,
            process.env.CRYPTKEY
          );
        });
    },


    setProfileData: function () {
      this.email = this.profile.email;
      this.name = this.profile.ACname;
      this.lastname = this.profile.ACsecondname;
      this.userToken = this.profile.userToken;
      this.token = this.profile.password;
      this.piva = this.profile.piva;
      this.company = this.profile.company;
      this.phone = this.profile.phone;
      this.role = this.profile.role;
      this.iban = this.profile.iban;
      this.cod = this.profile.cod;
      this.address = this.profile.address;
      this.privacy = this.profile.consent;
      this.group = this.profile.groupPh;
      this.cod_client = this.profile.cod;
      this.profileId = this.profile.id;
      
    },
    showConfirmReg() {
      var reg = this.accepted_regulations;

      if (reg[this.id]) {
      } else {
        this.$swal({
          type: "info",
          title: "Consenso necessario",
          html:
            '<p class="black">cliccando su conferma si accettano il <a class="link underline" target="_blank" href="' +
            this.contests.config.REGOLAMENTO +
            '" style="color: blue;"> termini e le condizioni di questa promozione </a>',
          confirmButtonText: "CONFERMA",
          confirmButton: "closeProductsModal",
          onClose: () => {
            this.$store.dispatch(ACCEPT_REG, this.id);
          },
        });
      }
    },
    activateMod: function (param) {
      this.modify = true;
      this.change = false;
      this.pricenew = param;
    },
    deactivateMod: function () {
      var _vue = this;
      this.pricenew = "";
      setTimeout(function () {
        _vue.modify = false;
      }, 100);
    },
    selectChange: function (param) {
      this.change = true;
      this.errProd = false;
    },
    priceMod(param) {
      var _vue = this;
      this.changeSecond = param;
    },
    myRegistration: async function () {
      if (this.piva != this.$route.params.piva) {
      } else {
        this.$track("myRegistration", "START");
        var data = {
          id: this.$route.params.id,
          piva: this.$route.params.piva,
          cod: this.$route.params.cod,
          group: this.group,
          profile: this.profile,
          promo:this.contests,
          id_platform: process.env.ID_PLATFORM,
          unique_key_db: process.env.UNIQUE_KEY_DB,
          vector_unique_key_db: process.env.ICODE,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          method: "POST",
          data: { data },
          url: process.env.ROOT_API + "api/myRegistration",
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            this.$track("myRegistration", "SUCCESS");
            this.$track("myRegistration", resp.data);
            if (resp.data) {
              this.maxRegistration =
                parseInt(resp.data[0].bonus) +
                parseInt(resp.data[0].extra_bonus);
              this.maxRegistrationOr = parseInt(resp.data[0].bonus);
            }
          })
          .catch((err) => {
            this.$track("myRegistration", "ERROR");
            err.response.data = this.$decryptByAES(
              err.response.data,
              process.env.CRYPTKEY
            );
          });
      }
    },
    calcToDate() {
      var _vue = this;
      var startRecDate = {
        year: moment(_vue.startRec_).year(),
        month: moment(_vue.startRec_).month(),
        day: moment(_vue.startRec_).day(),
      };
      var start = startRecDate;
      var date = new Date(new Date().setDate(new Date().getDate() - 5));
      var startDate = new Date(start.year, start.month - 1, start.day);
      if (startDate > date) {
        var finalTo = startDate;
      } else {
        var finalTo = startDate;
      }
      return finalTo;
    },
    calcFromDate() {
      var _vue = this;
      var endRecDate = {
        year: moment(_vue.endRec_).year(),
        month: moment(_vue.endRec_).month(),
        day: moment(_vue.endRec_).day(),
      };
      var stopObj = endRecDate;
      var stopDate = new Date(stopObj.year, stopObj.month - 1, stopObj.day + 1);
      var nowDate = new Date();
      if (nowDate <= stopDate) {
        var finalFrom = nowDate;
      } else {
        var finalFrom = stopDate;
      }
      return finalFrom;
    },
  },
  /********************************************************************************************* */
  watch: {
    "$route.params.id": {
      handler: function (id) {
        if (this.loaded) {
          //window.location.reload()
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.piva": {
      handler: function (id) {
        if (this.loaded) {
          //window.location.reload()
        }
      },
      deep: true,
      immediate: true,
    },
    "$route.params.phone": {
      handler: function (id) {
        if (this.loaded) {
          //window.location.reload()
        }
      },
      deep: true,
      immediate: true,
    },
    products: {
      handler(val) {
        var _vue = this;
        setTimeout(function () {
          //for ( var x in val ){
          if (_vue.productList[0]) {
            if (_vue.change) {
              _vue.products[_vue.changeSecond].price = "";
            }
            if (
              _vue.products[_vue.changeSecond].product &&
              !_vue.products[_vue.changeSecond].price &&
              !_vue.modify &&
              _vue.pricenew == ""
            ) {
              _vue.products[_vue.changeSecond].price =
                "" +
                _vue.productList[0][_vue.products[_vue.changeSecond].product];
              _vue.change = false;
            }
          }
          _vue.products[_vue.changeSecond].price = val[
            _vue.changeSecond
          ].price.replace(",", ".");
          _vue.products[_vue.changeSecond].price = val[
            _vue.changeSecond
          ].price.replace(/[`~!@#$£%^&*()_|+\-=?;:",<>\{\}\[\]\\\/]/gi, "");
          //}
        }, 100);
        this.checkProducts();
        this.calcTotPrice();
      },
      deep: true,
    },
    getProfile: function (val) {
      this.setProfileData();
      this.checkAccess();
      this.myRegistration();
      this.loadProducts();
      
    },
  },
  mounted: function () {
    this.checkSoftwareVersion()
    var id = this.$route.params.id;

    this.id = id;
    var piva = this.$route.params.piva;
    var cod = this.$route.params.cod;
    this.loadProducts();
    if (!piva || !cod) {
      this.$router.push("/");
    }
    this.setProfileData();
    if (this.getProfile.piva) {
      this.setProfileData();
      this.checkAccess();
      this.myRegistration();

      var _vue = this;
    }
    if (this.$route.params.phone == 1) {
      this.mobileUpl = true;
    }

    //this.getThisContest()
    var _vue = this;
    //_vue.setProfileData()
    setTimeout(function () {
      _vue.$scrollTo("#top", 0, { offset: -125 });
    }, 100);

    //this.takeMyAttempts()
    setTimeout(function () {
      _vue.disabledDates = {
        to: _vue.calcToDate(), // Disable all dates up to specific date
        from: _vue.calcFromDate(), // Disable all dates after specific date
      };

      _vue.scrollFinished = true;
    }, 1500);

  },
  created: async function () {
    await this.getThisContest();
    await this.setProfileData();
    this.takeMyAttempts();
    this.showConfirmReg();
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "isAuthenticated",
      "isProfileLoaded",
      "acceptCookies",
      "accepted_regulations",
    ]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
      profile: (state) => state.user.profile,
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/play/index.vue